import { Renderer } from '../../../../lib/dynamic_forms'

$(document).on('ready', () => {
  if ($('#admin-dynamic_forms-show').length !== 0) {
    (new Renderer('[selector="dynamic_form_preview"]')).render()
  }
})
